import React, { PropsWithChildren } from 'react';

import { Box } from '@betterment/samba-react';

const IntegrationListContainer: React.FC<PropsWithChildren> = ({ children }) => {
  const minWidth = '272px';

  return (
    <Box
      css={{
        alignItems: 'stretch',
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fit, minmax(${minWidth}, 1fr))`,
        mx: 'auto',
        pt: 'space.200',
        width: '100%',
        gap: 'space.300',
        mb: 'space.800',
        '@media (min-width: 618px)': {
          gridTemplateColumns: `repeat(2, minmax(${minWidth}, 50%))`,
        },
        '@media (min-width: 1484px)': {
          gridTemplateColumns: `repeat(3, minmax(${minWidth}, 32%))`,
        },
      }}
    >
      {children}
    </Box>
  );
};

export default IntegrationListContainer;
